import { render, staticRenderFns } from "./loginMxComp.vue?vue&type=template&id=9c0574f4&scoped=true&"
import script from "./loginMxComp.vue?vue&type=script&lang=js&"
export * from "./loginMxComp.vue?vue&type=script&lang=js&"
import style0 from "./loginMxComp.vue?vue&type=style&index=0&id=9c0574f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0574f4",
  null
  
)

export default component.exports